module.exports = __webpack_public_path__ + "static/media/WOW_highRes.85f4d935.png";